/* ═══════════════════════════════════════════════
   LUMAEXA v5 · Global behaviors
   - fade-up IntersectionObserver
   - Header transparent → solid on scroll
   - Hero parallax
   - Sticky ATC bar (product pages)
   - Product page countdown + viewers
   - Best Sellers Quick Add → variant ID via AJAX
   ═══════════════════════════════════════════════ */
(function(){
  'use strict';

  /* ───────────── Reveal animations ───────────── */
  if (typeof IntersectionObserver !== 'undefined') {
    var SELECTORS = '.fade-up, .fade-left, .fade-right';
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });

    function observeAll(root){
      (root || document).querySelectorAll(SELECTORS).forEach(function(el){
        if (!el.classList.contains('visible') && !el.dataset.lxObserved) {
          el.dataset.lxObserved = '1';
          io.observe(el);
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', observeAll);
    } else { observeAll(); }

    var mo = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        m.addedNodes.forEach(function(node){
          if (node.nodeType === 1) {
            if (node.matches && node.matches(SELECTORS) && !node.dataset.lxObserved){
              node.dataset.lxObserved = '1'; io.observe(node);
            }
            observeAll(node);
          }
        });
      });
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function(){
      document.querySelectorAll('.fade-up, .fade-left, .fade-right').forEach(function(el){
        el.classList.add('visible');
      });
    });
  }

  /* ───────────── Header scroll state ───────────── */
  function syncHeader(){
    if (window.scrollY > 40) document.body.classList.add('lx-scrolled');
    else document.body.classList.remove('lx-scrolled');
  }
  window.addEventListener('scroll', syncHeader, {passive:true});
  syncHeader();

  /* ───────────── Hero parallax ───────────── */
  function initParallax(){
    var bg = document.querySelector('[data-lx-parallax]');
    if (!bg) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches) return;
    var hero = bg.closest('.lx-hero') || bg.parentElement;
    var ticking = false;
    function update(){
      var rect = hero.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) { ticking=false; return; }
      var y = -rect.top * 0.32;
      bg.style.transform = 'translate3d(0,' + y.toFixed(2) + 'px,0)';
      ticking = false;
    }
    window.addEventListener('scroll', function(){
      if (!ticking) { requestAnimationFrame(update); ticking=true; }
    }, {passive:true});
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initParallax);
  else initParallax();

  /* ───────────── Quick Add (best sellers) ───────────── */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-lx-quickadd]');
    if (!btn) return;
    e.preventDefault();
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) { window.location.href = btn.getAttribute('data-url') || '/'; return; }
    var orig = btn.textContent;
    btn.textContent = 'ADDING…';
    btn.disabled = true;
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', '1');
    fetch((window.shopUrl || '') + '/cart/add.js', { method:'POST', body:fd, headers:{Accept:'application/json'} })
      .then(function(r){ return r.json(); })
      .then(function(){
        btn.textContent = '✓ ADDED';
        // Try open cart drawer if exists
        var cd = document.querySelector('cart-drawer');
        if (cd && cd.classList) {
          fetch((window.shopUrl||'') + '?section_id=cart-drawer').then(function(r){return r.text()}).then(function(html){
            var doc = new DOMParser().parseFromString(html,'text/html');
            var n = doc.querySelector('cart-drawer');
            if (n) cd.innerHTML = n.innerHTML;
            cd.classList.add('animate','active');
            document.body.classList.add('overflow-hidden');
          });
        }
        setTimeout(function(){
          btn.textContent = orig; btn.disabled = false;
        }, 1800);
      })
      .catch(function(){
        btn.textContent = orig; btn.disabled = false;
        if (btn.getAttribute('data-url')) window.location.href = btn.getAttribute('data-url');
      });
  });

  /* ───────────── Sticky ATC ───────────── */
  function initStickyATC(){
    var sticky = document.getElementById('lxSatc');
    if (!sticky) return;
    var mainBuyForm = document.querySelector('product-form form[action*="/cart/add"]') ||
                      document.querySelector('form[action*="/cart/add"]:not(#lxSatcForm)');
    var mainBuyBtn = mainBuyForm ? mainBuyForm.querySelector('button[type="submit"][name="add"], button[type="submit"]') : null;

    function update(){
      if (!mainBuyBtn) { sticky.classList.add('is-visible'); return; }
      var rect = mainBuyBtn.getBoundingClientRect();
      var visible = (rect.top < window.innerHeight - 60) && (rect.bottom > 0);
      sticky.classList.toggle('is-visible', !visible);
    }
    if (mainBuyBtn) {
      window.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update, {passive:true});
      update();
    }

    var stickyForm = document.getElementById('lxSatcForm');
    var stickyVar = document.getElementById('lxSatcVarId');
    var stickyBtn = document.getElementById('lxSatcBtn');

    document.addEventListener('change', function(e){
      if (e.target && (e.target.name === 'id' || (e.target.closest && e.target.closest('variant-radios, variant-selects, fieldset')))) {
        setTimeout(function(){
          var picker = document.querySelector('variant-radios input[type="radio"]:checked, variant-selects [name="id"], [name="id"]');
          if (picker && picker.value && stickyVar) stickyVar.value = picker.value;
        }, 30);
      }
    });

    if (stickyForm) {
      stickyForm.addEventListener('submit', function(e){
        e.preventDefault();
        if (stickyBtn.disabled) return;
        var orig = stickyBtn.innerHTML;
        stickyBtn.disabled = true; stickyBtn.innerHTML = 'ADDING…';
        var fd = new FormData(stickyForm);
        fetch((window.shopUrl||'') + '/cart/add.js', { method:'POST', body:fd, headers:{Accept:'application/json'} })
          .then(function(r){ return r.json(); })
          .then(function(){
            stickyBtn.innerHTML = '✓ ADDED';
            var cd = document.querySelector('cart-drawer');
            if (cd && cd.classList) {
              fetch((window.shopUrl||'') + '?section_id=cart-drawer').then(function(r){return r.text()}).then(function(html){
                var doc = new DOMParser().parseFromString(html,'text/html');
                var n = doc.querySelector('cart-drawer');
                if (n) cd.innerHTML = n.innerHTML;
                cd.classList.add('animate','active');
                document.body.classList.add('overflow-hidden');
              });
            }
            setTimeout(function(){
              stickyBtn.innerHTML = orig; stickyBtn.disabled = false;
            }, 1800);
          })
          .catch(function(){
            stickyBtn.innerHTML = orig; stickyBtn.disabled = false;
            window.location.href = '/cart';
          });
      });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initStickyATC);
  else initStickyATC();

  /* ───────────── Product page countdown + viewers ───────────── */
  function initProductWidgets(){
    var v = document.querySelector('[data-lx-viewers]');
    if (v) {
      // Range 18..24, refresh every 30s
      function pickViewers(){
        return 18 + Math.floor(Math.random() * 7);
      }
      v.textContent = pickViewers();
      setInterval(function(){ v.textContent = pickViewers(); }, 30000);
    }
    var c = document.querySelector('[data-lx-cutdown]');
    var del = document.querySelector('[data-lx-delivery]');
    if (c) {
      var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
      function tick(){
        var now = new Date();
        var cutoff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 23, 59, 59);
        if (cutoff < now) cutoff.setDate(cutoff.getDate()+1);
        var diff = cutoff - now;
        var h = Math.floor(diff/3600000);
        var m = Math.floor((diff%3600000)/60000);
        var s = Math.floor((diff%60000)/1000);
        var p = function(n){ return n < 10 ? '0'+n : n; };
        c.textContent = p(h)+':'+p(m)+':'+p(s);
        if (del) {
          var d2 = new Date(now); d2.setDate(d2.getDate() + 12);
          del.textContent = days[d2.getDay()] + ', ' + d2.toLocaleDateString(undefined,{month:'short',day:'numeric'});
        }
      }
      tick(); setInterval(tick, 1000);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductWidgets);
  else initProductWidgets();

})();
